import {  SESSION_INVALID, FETCH_MAIN_USER_SUCCESS } from "../actions/types";

export default (state = {
    error: null,
    users: [],
}, action) => {
    switch (action.type) {
        case FETCH_MAIN_USER_SUCCESS:
            return {
                ...state,
                users: action.payload,
                key: action.key,
                userArray: action.userArray
            }
            break;
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/mainUserReducer.js